import * as PIXI from 'pixi.js-legacy';
import Item from '../Item';

export default class Cover extends Item {
  constructor(args) {
    super(args);
    this.parentFrame = null;
  }

  draw() {
    const { scaledVertices } = this.data;

    this.childrenContainer = this.childrenContainer || new PIXI.Container();
    this.childrenContainer.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.childrenContainer.parent) {
      this.addChild(this.childrenContainer);
    }

    if (
      !this.parentItem ||
      !this.parentItem.itemid ||
      (this.parentFrame &&
        this.parentItem.itemid !== this.parentFrame.item.itemid)
    ) {
      if (this.parentFrame) {
        this.parentFrame.childrenContainer.removeChild(this);
        this.parentFrame && this.parentFrame.draw();
      }
      super.draw();
    } else {
      this.removeChildren();
    }

    this.parentFrame =
      this.parentItem &&
      this.app &&
      this.app.itemContainer &&
      this.app.itemContainer.getSprite(this.parentItem.itemid);
  }
  setHitArea() {
    this.hitArea = new PIXI.Polygon([]);
  }
  drawDropAreas() {}
  eraseDropAreas() {}
}
